import { useEffect, useState } from "react";
import {
  fetchAllPlans,
  createPlan,
  deactivatePlan,
  activatePlan,
} from "../services/adminPlanService";
import PlanTable from "../components/plans/PlanTable";
import PlanForm from "../components/plans/PlanForm";
import "../styles/SubscriptionPlansManagement.css";

const SubscriptionPlansManagement = () => {
  const [plans, setPlans] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const loadPlans = async () => {
    const res = await fetchAllPlans();
    console.log("Full response:", res);
    setPlans(res.data);
  };

  useEffect(() => {
    loadPlans();
  }, []);

  const handleCreate = async (data) => {
    await createPlan(data);
    setShowForm(false);
    loadPlans();
  };

  const handleToggleStatus = async (plan) => {
    if (plan.isActive) {
      await deactivatePlan(plan.id);
    } else {
      await activatePlan(plan.id);
    }
    loadPlans();
  };

  return (
    <div>
      <div className="plans-header">
        <h2>Subscription Plans</h2>
        <button onClick={() => setShowForm(true)}>+ Add Plan</button>
      </div>

      <PlanTable plans={plans} onToggleStatus={handleToggleStatus} />

      {showForm && (
        <PlanForm
          onSubmit={handleCreate}
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  );
};

export default SubscriptionPlansManagement;
